module.exports={
    "xs": "0",
    "sm": "640px",
    "md": "768px",
    "lg": "1024px",
    "xl": "1200px",
    "xxl": "1380px"
}
